import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getPasswordResetLink } from '../../../../../api';

export const adminUsersByIdLinksPasswordResetGetSlice = createGetAsyncSlice({
	name: 'AdminUsersByIdLinksPasswordReset',
	receive: true,
	request: true,
	requestHandler: getPasswordResetLink,
	retainDataOnRequest: false
});
